let lastScrollTop = 0;
const header = document.querySelector('.header-main');
const scrollThreshold = 0;


let menuItems = header.querySelectorAll('.menu-item');

gsap.to(menuItems, {
    opacity: 1,
    duration: 1,
    transform: 'translateY(0)',
    ease: 'power2.inOut',
    stagger: 0.1,
});
gsap.to(header.querySelector('.menu-area__inner'), {
    opacity: 1,
    duration: 0.5,
    ease: 'power2.inOut',
},'=');

window.addEventListener('scroll', function() {
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
    // top
    if (scrollTop <= 0) {
        header.classList.remove('header-hide');
        header.classList.remove('header-show');
        lastScrollTop = 0;
        return;
    }
    
    // Scrolldown
    if (scrollTop > lastScrollTop && scrollTop > scrollThreshold) {
        header.classList.add('header-hide');
        header.classList.remove('header-show');
    } 
    //scrollup
    else if (scrollTop < lastScrollTop) {
        header.classList.remove('header-hide');
        header.classList.add('header-show');
    }
    
    lastScrollTop = scrollTop;
});

const menuMobile = document.querySelector('.menu-mobile');
const menuToggles = document.querySelectorAll('.menu-toggle');
const menuMobileItems = menuMobile.querySelectorAll('.menu-item');
menuToggles.forEach(menuToggle => {
    menuToggle.addEventListener('click', function() {
        menuMobile.classList.toggle('active');
    });
});
menuMobileItems.forEach(menuMobileItem => {
    menuMobileItem.addEventListener('click', function() {
        menuMobile.classList.remove('active');
    });
});